// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3suHW","file":"styles_file__2uqJT"};